// Defer de trabalho pós-1º-paint — double-rAF, à prova do piso Chr38.
//
// Por que double-rAF: o callback do 1º `requestAnimationFrame` roda ANTES do
// paint do frame; o 2º garante que o 1º frame JÁ pintou. É o MESMO mecanismo que
// o main.tsx já usava pra a marca `boot:first-paint` — extraído aqui pra (a)
// reusar na hora de deferir o init do Sentry pra DEPOIS do paint e (b) ser
// testável (o guard "Sentry só inicia após o paint" vira teste de unidade).
//
// ⚠️ NÃO usar `requestIdleCallback`: é Chr47+ e NÃO existe no piso Chr38 —
// referenciá-lo lança ReferenceError e derruba o boot (tela branca no fleet
// 2017). `requestAnimationFrame` é Chr10+ (piso OK) e é o ÚNICO mecanismo seguro.
//
// Fallback: se rAF estiver indisponível (feature-detect) ou lançar (engine
// exótico), o callback ainda roda — síncrono. A marca de paint vira best-effort,
// mas o trabalho deferido (init do Sentry) NÃO pode se perder: o monitoramento
// tem que subir de qualquer jeito, só que fora do caminho síncrono do 1º paint.
export function deferAfterFirstPaint(cb: () => void): void {
  const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : undefined
  if (!raf) {
    cb()
    return
  }
  try {
    raf(() => raf(() => cb()))
  } catch {
    cb()
  }
}
